export const projectStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#e5e7eb', twcolor:'bg-gray-500', status:'New', shortStatus:'N'}
        case 1:
            return {value,color:'#d1fae5', twcolor:'bg-green-200', status:'InProgress', shortStatus:'IP'}
        case 2:
            return {value,color:'#fed7aa', twcolor:'bg-orange-200', status:'Paused', shortStatus:'P'}
        case 3:
            return {value,color:'#e9d5ff', twcolor:'bg-purple-200', status:'Finished', shortStatus:'F'}
        case 4:
            return {value,color:'#fecaca', twcolor:'bg-red-200', status:'Cancelled', shortStatus:'C'}
    }
})
export const isProjectFinished = (project) => {return project.status === 3}
export const isProjectCancelled = (project) => {return project.status === 4}

export const taskStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#e5e7eb', twcolor:'bg-gray-200', status:'New', shortStatus:'N', textColor:'#6B7280'}
        case 1:
            return {value,color:'#d1fae5', twcolor:'bg-green-200', status:'InProgress', shortStatus:'IP', textColor:'#3B82F6'}
        case 2:
            return {value,color:'#e9d5ff', twcolor:'bg-purple-200', status:'Finished', shortStatus:'F', textColor:'#22C55E'}
        case 3:
            return {value,color:'#fecaca', twcolor:'bg-red-200', status:'Cancelled', shortStatus:'C', textColor:'#EF4444'}
    }
})
export const isTaskFinished = (task) => {return task.status === 2}
export const isTaskCancelled = (task) => {return task.status === 3}


export const subtaskStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#e5e7eb', twcolor:'bg-gray-200', status:'New', shortStatus:'N'}
        case 1:
            return {value,color:'#d1fae5', twcolor:'bg-green-200', status:'InProgress', shortStatus:'IP'}
        case 2:
            return {value,color:'#e9d5ff', twcolor:'bg-purple-200', status:'Finished', shortStatus:'F'}
        case 3:
            return {value,color:'#fecaca', twcolor:'bg-red-200', status:'Cancelled', shortStatus:'C'}
    }
})

export const deadlineStatus = ((isAfter)=>{
    if(isAfter){
        return '#BBF7D0'
    }else{
        return '#FECACA'
    }
})

export const taskSizesEnum = ((value)=>{
    switch(value){
        default:
        case 1:
            return {value,size:'XS'}
        case 2:
            return {value,size:'S'}
        case 4:
            return {value,size:'M'}
        case 5:
            return {value,size:'L'}
        case 6:
            return {value,size:'XL'}
    }
})

export const taskSizesStringToEnum = ((size)=>{
    switch(size.toUpperCase()){
        default:
        case 'XS':
            return {value:1,size}
        case 'S':
            return {value:2,size}
        case 'M':
            return {value:4,size}
        case 'L':
            return {value:5,size}
        case 'XL':
            return {value:6,size}
    }
})

export const taskSizes = (()=>{
    return [taskSizesEnum(1),taskSizesEnum(2),taskSizesEnum(4),taskSizesEnum(5),taskSizesEnum(6)]
})

export const toolbarActions = {
    AddTask:'AddTask',
    AddBulkTask:'AddBulkTask',
    AddProject:'AddProject',
    AddSubtask:'AddSubtask',
    AddBulkSubtask:'AddBulkSubtask',
    AddResource:'AddResource',
    AddWorklog:'AddWorklog',
    Edit:'Edit',
    Start:'Start',
    Pause:'Pause',
    Finish:'Finish',
    Cancel:'Cancel',
    Delete:'Delete',
}

export const deadlineStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#10b981', twcolor:'bg-green-500', status:'OnSchedule', shortStatus:'N'}
        case 1:
            return {value,color:'#fbbf24', twcolor:'bg-yellow-400', status:'ApproachingDeadline', shortStatus:'IP'}
        case 2:
            return {value,color:'#fb923c', twcolor:'bg-orange-400', status:'AtRisk', shortStatus:'P'}
        case 3:
            return {value,color:'#ea580c', twcolor:'bg-orange-600', status:'HighRisk', shortStatus:'F'}
        case 4:
            return {value,color:'#ef4444', twcolor:'bg-red-500', status:'Overdue', shortStatus:'C'}
    }
})
